import { render } from "./UserPayment.vue?vue&type=template&id=776de6c5&ts=true"
import script from "./scripts/user-payment.ts?vue&type=script&lang=ts"
export * from "./scripts/user-payment.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__